function TermsConditions() {
  return (
    <>
      <section className="bg-primary py-20 text-center text-white">
        <h1 className="text-3xl font-bold">Terms and Conditions</h1>
        <h6 className="text-xs font-semibold">
          Please read these Terms carefully, and contact us if you have any questions.
        </h6>
      </section>
      <section className="main-container mx-auto mt-10 w-1/2 space-y-6 pb-20 font-sora text-white">
        <p>
          This Privacy Policy governs the manner in which MAGENTIQ collects, uses, maintains, and discloses information
          collected from users (each, a "User") of the www.magentiq.tech website ("Site"). This privacy policy applies
          to the Site and all products and services offered by MAGENTIQ.
        </p>
        <div>
          <h1 className="text-xl font-bold">Personal identification information</h1>
          <p>
            We may collect personal identification information from Users in a variety of ways, including, but not
            limited to, when Users visit our site, subscribe to the newsletter, and in connection with other activities,
            services, features, or resources we make available on our Site. Users may visit our Site anonymously. We
            will collect personal identification information from Users only if they voluntarily submit such information
            to us. Users can always refuse to supply personally identification information, except that it may prevent
            them from engaging in certain Site related activities.
          </p>
        </div>
        <div>
          <h1 className="text-xl font-bold">Non-personal identification information</h1>
          <p>
            We may collect non-personal identification information about Users whenever they interact with our Site.
            Non-personal identification information may include the browser name, the type of computer and technical
            information about Users means of connection to our Sites, such as the operating system and the Internet
            service providers utilized and other similar information.
          </p>
        </div>{" "}
        <div>
          <h1 className="text-xl font-bold">Web browser cookies</h1>
          <p>
            Our Site may use "cookies" to enhance User experience. User's web browser places cookies on their hard drive
            for record-keeping purposes and sometimes to track information about them. Users may choose to set their web
            browser to refuse cookies or to alert you when cookies are being sent. If they do so, note that some parts
            of the Site may not function properly.
          </p>
        </div>{" "}
        <div>
          <h1 className="text-xl font-bold">How we protect your information</h1>
          <p>
            We adopt appropriate data collection, storage and processing practices and security measures to protect
            against unauthorized access, alteration, disclosure or destruction of your personal information, username,
            password, transaction information and data stored on our Site.
          </p>
        </div>{" "}
        <div>
          <h1 className="text-xl font-bold">Sharing your personal information</h1>
          <p>
            We do not sell, trade, or rent User's personal identification information to others. We may share generic
            aggregated demographic information not linked to any personal identification information regarding visitors
            and users with our business partners, trusted affiliates, and advertisers for the purposes outlined above.
            We may use third-party service providers to help us operate our business and the Site or administer
            activities on our behalf, such as sending out newsletters or surveys. We may share your information with
            these third parties for those limited purposes provided that you have given us your permission.
          </p>
        </div>
      </section>
    </>
  );
}

export default TermsConditions;
